<style lang="scss" scoped>
@import "$vars";
.modal {
  z-index: 500
}
.btn-md {
  transform: scale(0.8)
}
.btn {
  color: white;
  background: $color-green;
  &.cancel {
    color: $color-green;
    border: 1px solid $color-green !important;
    background: white

  }
}
</style>

<template>
  <form @submit.prevent="submit()" class="modal modal-md active" v-if="active != null" id="modal-id">
    <a @click="close()" class="modal-overlay" aria-label="Close"></a>
    <div class="modal-container">
      <div class="modal-header">
        <h4>Adicionar conta</h4>
      </div>
      <div class="modal-body">
        <div class="content columns">
          <template v-for="(field, name) in formData">
            <dr-field
              v-bind:form.sync="formData"
              v-bind:validators.sync="$v.formData[name]"
              v-bind:field.sync="field"
              v-bind:apiErrors.sync="apiErrors[name]"
              :id="name"
              :ref="name"
              v-if="name !== 'bank'"
              :key="'main_'+name"
            >
            </dr-field>
            <div
              class="form-group col-12"
              :key="'main_'+name"
              v-if="name === 'bank'"
              >
              <label class="form-label">Banco</label>
              <dr-autocomplete
                ref="autocomplete_bank"
                :format="'{$name}'"
                :options="field.options"
                :fields="['name']"
                :value="getBank(field.value)"
                placeholder="Preencha seu banco"
                @change="formData.bank.value = $event"
                >
              </dr-autocomplete>
            </div>
          </template>
        </div>
        <br />
        <footer class="col-12 d-flex">
          <button type="button" @click="close()" :disabled="sending" :class="sending ? 'disabled' : ''" class="btn btn-md cancel">Cancelar</button>
          <dr-submit class="btn-md" :disabled="$v.$invalid" :text="active > -1 ? 'Alterar conta' : 'Criar conta'" :sending.sync="sending"></dr-submit>
        </footer>
      </div>
    </div>
  </form>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import drAutocomplete from '@/components/form/autocomplete'
import {formData, validations} from '@/data/formData/bankAccount.js'

export default {
  name: 'gagdgadgda',
  components: {
    drField,
    drSubmit,
    drAutocomplete
  },
  props: [
    'active',
    'bankAccounts',
    'banks'
  ],
  data () {
    return {
      sending: false,
      formData: formData,
      localActive: true,
      apiErrors: this.fn_BUILD_API_ERRORS(formData)
    }
  },
  validations: {
    formData: validations
  },
  mounted () {
    if (this.active > -1) {
      for (let field in this.bankAccounts[this.active]) {
        if (this.formData[this.fn_TO_CAMELCASE(field)]) {
          this.formData[this.fn_TO_CAMELCASE(field)].value = this.bankAccounts[this.active][field].value
        }
      }
      this.formData.bank.value = this.bankAccounts[this.active]['bank'].id
    } else {
      console.log(this.$refs.autocomplete_bank)
      this.$refs.autocomplete_bank[0].searchTerm = null
      for (let field in this.formData) {
        this.formData[field].value = null
      }
    }
    this.formData.isActive.value ? this.formData.isActive.value = true : this.formData.isActive.value = false
    this.formData.bank.options = this.banks
  },
  methods: {
    getBank (id) {
      for (let bank of this.banks) {
        if (bank.id === id) {
          return bank.name
        }
      }
    },
    close () {
      if (this.sending) {
        return
      }
      this.localActive = false
      this.$emit('cancel', true)
    },
    submit () {
      const self = this
      function handleErrors (err) {
        if (err.status === 400 || err.code === 400) {
          self.fn_FLATTEN_OBJECT(err.errors.children).then(
            (res) => {
              for (let field in res) {
                self.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
              }
              self.sending = false
              self.fn_HIDE_PROGRESS()
              self.$store.dispatch('setModalAlert', self.ERROR_MESSAGES.modal.form)
            }
          )
        } else {
          console.log(err)
          self.sending = false
          self.fn_HIDE_PROGRESS()
          self.$store.dispatch('setModalAlert', self.ERROR_MESSAGES.modal.server)
        }
      }
      this.sending = true
      this.fn_SHOW_PROGRESS()
      let data = this.fn_EXPAND_OBJECT(this.formData)
      data.isActive ? data.isActive = 1 : data.isActive = 0
      if (this.active === -1) {
        this.$http.post(`/doctor/bank_detail`, {bank_detail: data}, this.$store.getters.getAuthHeader).then(
          (res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Conta criada com sucesso',
              size: 'md',
              active: true
            })
            this.$emit('success', true)
            this.fn_HIDE_PROGRESS()
            this.localActive = false
          }
        ).catch((err) => {
          handleErrors(err)
        })
      } else {
        this.$http.put(`/doctor/bank_detail/${this.bankAccounts[this.active].id}`, {bank_detail: data}, this.$store.getters.getAuthHeader).then(
          (res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Conta atualizada com sucesso',
              size: 'md',
              active: true
            })
            this.$emit('success', true)
            this.fn_HIDE_PROGRESS()
            this.localActive = false
          }
        ).catch((err) => {
          console.log(data)
          handleErrors(err)
        })
      }
    }
  },
  updated () {
    // this.sending = false
  }
}
</script>
